import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
document.title = 'Caveo // Digital safety your family will actually do';
render(<AppRouter data-id="element-404" />, document.getElementById('root'));